<div class="ov-wrap">

  <!-- Loading skeleton (dashboard style) -->
  <ng-container *ngIf="loadingOverview">
    <div class="ov-summary">
      <div class="ov-summary-item" *ngFor="let i of [1,2,3]">
        <span class="skeleton ov-summary-skel-icon"></span>
        <div class="ov-summary-text">
          <span class="skeleton ov-summary-skel-label"></span>
          <span class="skeleton ov-summary-skel-value"></span>
        </div>
      </div>
    </div>
    <div class="ov-row">
      <div class="ov-card-skel" *ngFor="let i of [1,2]">
        <div class="ov-skel-header">
          <div class="skeleton ov-skel-title"></div>
          <div class="skeleton ov-skel-icon"></div>
        </div>
        <div class="skeleton ov-skel-chart"></div>
      </div>
    </div>
  </ng-container>

  <!-- Error -->
  <div class="ov-state-block" *ngIf="!loadingOverview && overviewError">
    <i class="pi pi-exclamation-circle"></i>
    <p>We couldn't load the overview.</p>
    <button pButton type="button" label="Try again" class="ov-retry-btn" (click)="retry()"></button>
  </div>

  <!-- Content -->
  <ng-container *ngIf="!loadingOverview && !overviewError && overview">

    <!-- Summary strip -->
    <div class="ov-summary">
      <div class="ov-summary-item">
        <span class="ov-summary-icon icon-blue"><i class="pi pi-users"></i></span>
        <div class="ov-summary-text">
          <span class="ov-summary-label">Total registered</span>
          <span class="ov-summary-value">{{ overview.kpis.total_registrations }}</span>
        </div>
      </div>

      <div class="ov-summary-item">
        <span class="ov-summary-icon icon-violet"><i class="pi pi-spinner-dotted"></i></span>
        <div class="ov-summary-text">
          <span class="ov-summary-label">Active in pipeline</span>
          <span class="ov-summary-value">{{ overview.kpis.active_in_pipeline }}</span>
        </div>
      </div>

      <div class="ov-summary-item">
        <span class="ov-summary-icon icon-green"><i class="pi pi-share-alt"></i></span>
        <div class="ov-summary-text">
          <span class="ov-summary-label">Top source</span>
          <span class="ov-summary-value" *ngIf="overview.kpis.top_source; else noSrc">
            {{ overview.kpis.top_source }}<span class="ov-summary-muted"> · {{ overview.kpis.top_source_count }}</span>
          </span>
          <ng-template #noSrc><span class="ov-summary-value">—</span></ng-template>
        </div>
      </div>

      <div class="ov-download" (click)="$event.stopPropagation()">
        <button type="button" class="ov-dl-btn" [class.busy]="isGeneratingPdf"
          (click)="toggleDownloadMenu()" aria-label="Download overview" title="Download">
          <i class="pi" [ngClass]="isGeneratingPdf ? 'pi-spin pi-spinner' : 'pi-download'"></i>
        </button>
        <div class="ov-dl-menu" *ngIf="showDownloadMenu">
          <button type="button" (click)="downloadPdf()"><i class="pi pi-file-pdf"></i> Download as PDF</button>
          <button type="button" (click)="downloadCsv()"><i class="pi pi-file-excel"></i> Download as CSV</button>
        </div>
      </div>
    </div>

    <!-- Stage pipeline + breakdown -->
    <div class="ov-row">

      <!-- Pipeline list -->
      <div class="ov-card">
        <div class="ov-hd">
          <div class="ov-hd-row">
            <img src="assets/icons-svg/hierarchy.svg" alt="" class="ov-hd-icon-img">
            <div class="ov-hd-title">Stage pipeline</div>
          </div>
          <div class="ov-hd-sub">Candidates currently in each stage</div>
        </div>

        <div class="ov-stage-list">
          <button type="button" class="ov-stage-item"
            *ngFor="let stage of overview.stage_pipeline; trackBy: trackByStage"
            [class.sel]="selectedStage?.stage_uuid === stage.stage_uuid"
            (click)="selectStage(stage)">
            <span class="ov-dot" [style.background]="stageColor(stage.type)"></span>
            <span class="ov-stage-name">{{ stage.name }}</span>
            <span class="ov-stage-type" [ngClass]="stageTagClass(stage.type)">{{ stage.type }}</span>
            <span class="ov-stage-count">{{ stage.count }}</span>
            <i class="pi pi-chevron-right ov-stage-chev"></i>
          </button>
        </div>
      </div>

      <!-- Breakdown panel -->
      <div class="ov-card">
        <div class="ov-hd">
          <div class="ov-hd-bar">
            <div class="ov-hd-row">
              <img src="assets/icons-svg/Stages Icon.svg" alt="" class="ov-hd-icon-img">
              <div class="ov-hd-title">{{ selectedStage ? selectedStage.name : 'Stage breakdown' }}</div>
            </div>
            <div class="ov-view-toggle" *ngIf="selectedStage && !loadingStage && stageBreakdown">
              <button type="button" [class.active]="breakdownView === 'table'"
                (click)="breakdownView = 'table'" aria-label="Table view">
                <i class="pi pi-align-justify"></i><span>Table</span>
              </button>
              <button type="button" [class.active]="breakdownView === 'chart'"
                (click)="breakdownView = 'chart'" aria-label="Chart view">
                <i class="pi pi-chart-pie"></i><span>Chart</span>
              </button>
            </div>
          </div>
          <div class="ov-hd-sub">{{ selectedStage ? selectedStage.type : 'Select a stage to see its status split' }}</div>
        </div>

        <!-- Empty (nothing selected): pipeline distribution as a doughnut -->
        <div class="ov-empty-pick" *ngIf="!selectedStage">
          <ng-container *ngIf="pipelineChartData.length; else noPipeline">
            <p class="ov-empty-pick-hint">Select a stage from the left to view detailed analysis</p>
            <div class="ov-pipeline-canvas">
              <canvas #pipelineCanvas></canvas>
            </div>
            <div class="ov-legend">
              <span class="ov-legend-item" *ngFor="let l of pipelineLegend">
                <span class="ov-legend-dot" [style.background]="l.color"></span>{{ l.label }}
              </span>
            </div>
          </ng-container>
          <ng-template #noPipeline>
            <div class="ov-state-soft small"><p>No candidates in any stage yet.</p></div>
          </ng-template>
        </div>

        <!-- Loading the breakdown — skeleton mirroring the status table -->
        <div class="ov-bd-skeleton" *ngIf="selectedStage && loadingStage">
          <span class="skeleton ov-ctx-skel"></span>
          <div class="ov-bd-table">
            <div class="ov-bd-head">
              <span class="ov-bd-no">No.</span>
              <span class="ov-bd-status">Status</span>
              <span class="ov-bd-count">Count</span>
              <span class="ov-bd-arrow"></span>
            </div>
            <div class="ov-bd-row" *ngFor="let i of [1, 2, 3, 4, 5, 6]">
              <span class="ov-bd-no"><span class="skeleton ov-sk-no"></span></span>
              <span class="ov-bd-status">
                <span class="skeleton ov-sk-dot"></span>
                <span class="skeleton ov-sk-label"></span>
              </span>
              <span class="ov-bd-count"><span class="skeleton ov-sk-count"></span></span>
              <span class="ov-bd-arrow"></span>
            </div>
          </div>
        </div>

        <ng-container *ngIf="selectedStage && !loadingStage && stageBreakdown">
          <div class="ov-ctx">
            <i class="pi pi-info-circle"></i>
            {{ stageBreakdown.entered }} entered · {{ stageBreakdown.moved_on }} moved on
          </div>

          <!-- Table view (default) -->
          <ng-container *ngIf="breakdownView === 'table'">
            <ng-container *ngIf="stageBreakdown.tiles.length; else noTiles">
              <div class="ov-bd-table">
                <div class="ov-bd-head">
                  <span class="ov-bd-no">No.</span>
                  <span class="ov-bd-status">Status</span>
                  <span class="ov-bd-count">Count</span>
                  <span class="ov-bd-arrow"></span>
                </div>
                <button type="button" class="ov-bd-row"
                  *ngFor="let tile of stageBreakdown.tiles; let i = index; trackBy: trackByTile"
                  [class.clickable]="tileHasView(tile)"
                  (click)="tileHasView(tile) && openTileView(tile)">
                  <span class="ov-bd-no">{{ i + 1 | number: '2.0-0' }}</span>
                  <span class="ov-bd-status">
                    <span class="ov-bd-dot" [style.background]="tileColor(i)"></span>
                    {{ tile.label }}
                  </span>
                  <span class="ov-bd-count">{{ tile.count }}</span>
                  <span class="ov-bd-arrow"><i class="pi pi-arrow-up-right" *ngIf="tileHasView(tile)"></i></span>
                </button>
              </div>
            </ng-container>
            <ng-template #noTiles>
              <div class="ov-state-soft small">
                <p>No breakdown available for this stage type.</p>
              </div>
            </ng-template>
          </ng-container>

          <!-- Chart view -->
          <ng-container *ngIf="breakdownView === 'chart'">
            <div class="ov-chart-view" *ngIf="stageChartData.length; else noChart">
              <div class="ov-chart-ring">
                <div class="ov-chart-canvas">
                  <canvas #breakdownCanvas></canvas>
                </div>
              </div>
              <div class="ov-legend">
                <span class="ov-legend-item" *ngFor="let l of stageLegend">
                  <span class="ov-legend-dot" [style.background]="l.color"></span>{{ l.label }}
                </span>
              </div>
            </div>
            <ng-template #noChart>
              <div class="ov-state-soft"><p>Nothing to chart for this stage.</p></div>
            </ng-template>
          </ng-container>
        </ng-container>
      </div>
    </div>

    <!-- Timeline + action needed -->
    <div class="ov-row">

      <!-- Event timeline -->
      <div class="ov-card">
        <div class="ov-hd">
          <div class="ov-hd-row">
            <i class="pi pi-calendar ov-hd-icon"></i>
            <div class="ov-hd-title">Event timeline</div>
          </div>
          <div class="ov-hd-sub">Duration and key dates</div>
        </div>

        <ng-container *ngIf="timeline; else noTimeline">
          <div class="ov-tl-strip">
            <div class="ov-tl-top">
              <span>{{ timeline.startDate | date: 'MMM d, y' }}</span>
              <span class="ov-tl-today" *ngIf="!timeline.eventEnded">Today · {{ today | date: 'MMM d' }}</span>
              <span>{{ timeline.endDate | date: 'MMM d, y' }}</span>
            </div>
            <div class="ov-tl-bar">
              <div class="ov-tl-bar-fill" [style.width.%]="timeline.elapsedPct"></div>
            </div>
            <div class="ov-tl-lbl">{{ timeline.elapsedPct }}% elapsed · {{ timeline.daysRemaining }} days remaining</div>
          </div>

          <div class="ov-meta-grid">
            <div class="ov-meta">
              <div class="ov-meta-k">Registration closes</div>
              <div class="ov-meta-v accent" *ngIf="timeline.regEndDate; else noReg">
                <ng-container *ngIf="!timeline.regClosed; else regClosed">
                  {{ timeline.regEndDate | date: 'MMM d' }}<span *ngIf="timeline.regCloseDays !== null"> ·
                    {{ timeline.regCloseDays }} days</span>
                </ng-container>
                <ng-template #regClosed>Registration closed</ng-template>
              </div>
              <ng-template #noReg><div class="ov-meta-v">—</div></ng-template>
            </div>
            <div class="ov-meta">
              <div class="ov-meta-k">Total stages</div>
              <div class="ov-meta-v">{{ overview.event.total_stages }}</div>
            </div>
            <div class="ov-meta">
              <div class="ov-meta-k">Type</div>
              <div class="ov-meta-v">{{ overview.event.type || '—' }}</div>
            </div>
            <div class="ov-meta">
              <div class="ov-meta-k">Category</div>
              <div class="ov-meta-v">{{ overview.event.category || '—' }}</div>
            </div>
          </div>
        </ng-container>

        <ng-template #noTimeline>
          <div class="ov-state-soft small"><p>Timeline dates not available.</p></div>
        </ng-template>
      </div>

      <!-- Action needed -->
      <div class="ov-card">
        <div class="ov-hd">
          <div class="ov-hd-row">
            <i class="pi pi-exclamation-triangle ov-hd-icon"></i>
            <div class="ov-hd-title">Action needed</div>
          </div>
          <div class="ov-hd-sub">Items that need your attention</div>
        </div>

        <ng-container *ngIf="overview.action_needed.length; else noActions">
          <div class="ov-action" *ngFor="let item of overview.action_needed" [attr.data-sev]="item.severity">
            <span class="ov-action-dot"></span>
            <div class="ov-action-body">
              <div class="ov-action-text">{{ item.label }}</div>
              <span class="ov-action-tag">{{ item.tag }}</span>
            </div>
          </div>
        </ng-container>

        <ng-template #noActions>
          <div class="ov-state-soft">
            <i class="pi pi-check-circle ok"></i>
            <p>Nothing needs attention right now.</p>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-container>

  <div class="ov-report" #reportArea *ngIf="buildingReport && overview">
    <div class="ov-rp-head">
      <div>
        <div class="ov-rp-logo">NEOHIRE</div>
        <div class="ov-rp-kicker">Event Overview Report</div>
      </div>
      <div class="ov-rp-event">
        <h2>{{ overview.event.name }}</h2>
        <p>{{ overview.event.type || '—' }}<span *ngIf="overview.event.category"> · {{ overview.event.category }}</span></p>
        <p class="ov-rp-date">Generated {{ today | date: 'MMM d, y' }}</p>
      </div>
    </div>

    <div class="ov-rp-kpis">
      <div class="ov-rp-kpi kpi-blue">
        <span>Total registered</span><strong>{{ overview.kpis.total_registrations }}</strong>
      </div>
      <div class="ov-rp-kpi kpi-violet">
        <span>Active in pipeline</span><strong>{{ overview.kpis.active_in_pipeline }}</strong>
      </div>
      <div class="ov-rp-kpi kpi-green">
        <span>Top source</span>
        <strong>{{ overview.kpis.top_source || '—' }}<ng-container
            *ngIf="overview.kpis.top_source"> · {{ overview.kpis.top_source_count }}</ng-container></strong>
      </div>
    </div>

    <h3 class="ov-rp-h2">Stage breakdown</h3>
    <div class="ov-rp-stage" *ngFor="let r of reportBreakdowns">
      <div class="ov-rp-stage-head">
        <span class="ov-rp-dot" [style.background]="stageColor(r.stage.type)"></span>
        <span class="ov-rp-stage-name">{{ r.stage.name }}</span>
        <span class="ov-rp-stage-type" [ngClass]="stageTagClass(r.stage.type)">{{ r.stage.type }}</span>
        <span class="ov-rp-stage-total">{{ r.entered }} entered · {{ r.moved_on }} moved on</span>
      </div>
      <table class="ov-rp-table" *ngIf="r.tiles.length; else rpNoTiles">
        <tr *ngFor="let t of r.tiles; let ti = index">
          <td><span class="ov-rp-tdot" [style.background]="tileColor(ti)"></span>{{ t.label }}</td>
          <td>{{ t.count }}</td>
        </tr>
      </table>
      <ng-template #rpNoTiles>
        <div class="ov-rp-empty">No breakdown for this stage type.</div>
      </ng-template>
    </div>

    <div class="ov-rp-footer">NeoHire · Event Overview · {{ overview.event.name }}</div>
  </div>
</div>
